import * as THREE from "three";

export class SceneDimmer
{
  public static readonly BACKGROUND_LAYER = 6;

  private static active = false;
  private static opacity = 0.78;

  private static veil_scene: THREE.Scene | null = null;
  private static veil_camera: THREE.OrthographicCamera | null = null;
  private static veil_material: THREE.MeshBasicMaterial | null = null;

  private static restore_masks = new Map<THREE.Object3D, number>();

  public static isActive(): boolean
  {
    return this.active;
  }

  public static getOpacity(): number
  {
    return this.opacity;
  }

  public static enable( scene: THREE.Scene, background_roots: THREE.Object3D[], opacity: number ): void
  {
    this.disable();

    this.opacity = opacity;

    for ( const root of background_roots )
    {
      root.traverse( object =>
      {
        if ( this.restore_masks.has( object ) )
          return;

        this.restore_masks.set( object, object.layers.mask );
        object.layers.set( this.BACKGROUND_LAYER );
      } );
    }

    scene.traverse( object =>
    {
      if ( !( object as THREE.Light ).isLight )
        return;

      if ( !this.restore_masks.has( object ) )
        this.restore_masks.set( object, object.layers.mask );

      object.layers.enable( this.BACKGROUND_LAYER );
    } );

    this.active = true;
  }

  public static disable(): void
  {
    for ( const [ object, mask ] of this.restore_masks )
      object.layers.mask = mask;

    this.restore_masks.clear();
    this.active = false;
  }

  public static renderVeil( renderer: THREE.WebGLRenderer ): void
  {
    this.ensureVeil();
    this.veil_material!.opacity = this.opacity;
    renderer.render( this.veil_scene!, this.veil_camera! );
  }

  private static ensureVeil(): void
  {
    if ( this.veil_scene )
      return;

    this.veil_material = new THREE.MeshBasicMaterial( {
      color: 0x000000,
      transparent: true,
      opacity: this.opacity,
      depthTest: false,
      depthWrite: false,
      toneMapped: false,
    } );

    const quad = new THREE.Mesh( new THREE.PlaneGeometry( 2, 2 ), this.veil_material );
    quad.frustumCulled = false;

    this.veil_scene = new THREE.Scene();
    this.veil_scene.add( quad );

    this.veil_camera = new THREE.OrthographicCamera( -1, 1, 1, -1, 0, 1 );
  }
}
